import {useComponent} from "@/utils/compossable/$component";
import {useMemberStore} from "@/services/store/memberStore";

class TokenService {
    /**
     * sessionStorage의 RefreshToken 조회
     * @returns {*}
     */
    getLocalRefreshToken() {
        const user = JSON.parse(sessionStorage.getItem("user"));
        return user?.refToken;
    }

    /**
     * sessionStorage의 AccessToken 조회
     * @returns {string|*}
     */
    getLocalAccessToken() {
        const user = JSON.parse(sessionStorage.getItem("user"));
        return user?.accToken;
    }

    /**
     * sessionStorage에 AccessToken 받아온 토큰 업데이트
     * @param token
     */
    updateLocalAccessToken(token) {
        let storageToken = JSON.parse(sessionStorage.getItem("token"));
        storageToken.accToken = token;
        sessionStorage.setItem("token", JSON.stringify(storageToken));
    }

    /**
     * sessionStorage에 RefreshToken 받아온 토큰 업데이트
     * @param token
     */
    updateLocalRefreshToken(token) {
        let storageToken = JSON.parse(sessionStorage.getItem("token"));
        storageToken.refToken = token;
        sessionStorage.setItem("token", JSON.stringify(storageToken));
    }

    /**
     * 유저정보 조회
     * @returns {any}
     */
    getUser() {
        return JSON.parse(sessionStorage.getItem("user"));
    }

    /**
     * 유저정보 sessionStorage에 셋팅
     * @param user
     */
    setUser(user) {
        const member = user.member;
        sessionStorage.setItem("user", JSON.stringify(member));
        delete user.member;
        sessionStorage.setItem("token", JSON.stringify(user));
        this.setTokenLastTime();
    }

    /**t
     * sessionStorage에서 유저정보 삭제
     */
    removeUser() {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("user");
    }

    /**
     * 토큰 로그인, 비로그인 상태에서 교체
     * @param data
     */
    updateToken(data) {
        const store = useMemberStore();
        if (store.member.status.isLogin) {
            let tokenData = JSON.parse(sessionStorage.getItem('token'));
            tokenData.accToken = data.result.accToken;

            tokenData.actorId = data.result?.actorId ?? tokenData.actorId;

            tokenData.refToken = data.result.refToken;

            sessionStorage.setItem("token", JSON.stringify(tokenData));

            //토큰타이머 시작
            this.setTokenLastTime();
        } else {
            sessionStorage.setItem("token", JSON.stringify(data.result));
        }
    }

    /**
     * 현재 토큰 시간 계산
     */
    setTokenLastTime = () => {
        const store = useMemberStore();
        const $component = useComponent();
        store.member.tokenTimeCheck = false;
        $component.setTimer();
    }
}

export default new TokenService();